import React, { useMemo, useState } from 'react';
import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import { AlterarIds, AptidaoIrrigacao, ConverterColeta, MapsGsi,
    PivoEmZonas, PontosZonas } from './geoprocessamento';
import Calibracao from './calibracao';
import { Compactacao, Extracao, Laboratorio, MapaSementes } from './planilhas';
import Documentos from './documentos';
import GestaoAreas from './gestaoAreas';

const ferramentas = [
    { id: 'converter', titulo: 'Converter para Coleta', grupo: 'Geoprocessamento', icon: 'fa-draw-polygon', componente: ConverterColeta },
    { id: 'pontos-zonas', titulo: 'Conferir Pontos e Zonas', grupo: 'Geoprocessamento', icon: 'fa-map-pin', componente: PontosZonas },
    { id: 'maps', titulo: 'Maps GSI', grupo: 'Geoprocessamento', icon: 'fa-route', componente: MapsGsi },
    { id: 'compactacao', titulo: 'Compactação do Solo', grupo: 'Planilhas', icon: 'fa-layer-group', componente: Compactacao },
    { id: 'aptidao', titulo: 'Aptidão de Irrigação', grupo: 'Planilhas', icon: 'fa-tint', componente: AptidaoIrrigacao },
    { id: 'laboratorio', titulo: 'Laboratório GSI547', grupo: 'Planilhas', icon: 'fa-flask', componente: Laboratorio },
    { id: 'extracao', titulo: 'Extração e Exportação', grupo: 'Planilhas', icon: 'fa-file-excel', componente: Extracao },
    { id: 'semente', titulo: 'Mapa de Sementes', grupo: 'Planilhas', icon: 'fa-seedling', componente: MapaSementes },
    { id: 'pivo', titulo: 'Pivô em Zonas', grupo: 'Geoprocessamento', icon: 'fa-bullseye', componente: PivoEmZonas },
    { id: 'relatorios', titulo: 'Relatórios e PDFs', grupo: 'Documentos', icon: 'fa-file-pdf', componente: Documentos },
    { id: 'calibracao', titulo: 'Calibração', grupo: 'Cálculos', icon: 'fa-calculator', componente: Calibracao },
    { id: 'areas', titulo: 'Gestão de Áreas', grupo: 'Planejamento', icon: 'fa-chart-area', componente: GestaoAreas },
    { id: 'agenda', titulo: 'Agenda Semanal', grupo: 'Planejamento', icon: 'fa-calendar-week', rota: '/agenda' },
    { id: 'ids', titulo: 'Alterar IDs', grupo: 'Geoprocessamento', icon: 'fa-sort-numeric-down', componente: AlterarIds }
];

const Cartao = ({ item, abrir }) => <button type='button' onClick={() => abrir(item)}
    className='card text-left border-0 shadow-sm'
    style={{ width: '100%', minHeight: 125, cursor: 'pointer', background: '#fff' }}>
    <div className='card-body d-flex align-items-center'>
        <span className='mr-3 d-flex align-items-center justify-content-center'
            style={{ width: 48, height: 48, borderRadius: 12, color: '#fff', background: '#44942c', fontSize: 20 }}>
            <i className={`fas ${item.icon}`} />
        </span>
        <span><small className='text-muted'>{item.grupo}</small>
            <strong className='d-block'>{item.titulo}</strong></span>
    </div>
</button>;

export default props => {
    const parametro = new URLSearchParams(props.location.search).get('ferramenta');
    const inicial = ferramentas.find(item => item.id === parametro) || null;
    const [selecionada, setSelecionada] = useState(inicial);
    const grupos = useMemo(() => [...new Set(ferramentas.map(item => item.grupo))], []);
    const abrir = item => {
        if (item.rota) return props.history.push(item.rota);
        setSelecionada(item);
        props.history.replace(`/ferramentas?ferramenta=${item.id}`);
    };
    if (selecionada) {
        const Componente = selecionada.componente;
        return <Content><ContentCard>
            <ContentCardHeader>
                <button className='btn btn-light mr-2' type='button' onClick={() => {
                    setSelecionada(null); props.history.replace('/ferramentas');
                }}><i className='fas fa-arrow-left mr-2' />Ferramentas</button>
                <strong>{selecionada.titulo}</strong>
            </ContentCardHeader>
            <ContentCardBody>{Componente ? <Componente /> :
                <div className='alert alert-info mb-0'>Esta ferramenta está sendo adaptada para os padrões do GSI Agro.</div>}
            </ContentCardBody>
        </ContentCard></Content>;
    }
    return <Content><ContentCard>
        <ContentCardHeader><strong>Ferramentas Operacionais</strong></ContentCardHeader>
        <ContentCardBody>
            {grupos.map(grupo => <section key={grupo} className='mb-4'>
                <h6 className='text-uppercase text-muted mb-3'>{grupo}</h6>
                <div className='row'>{ferramentas.filter(item => item.grupo === grupo).map(item =>
                    <div className='col-lg-3 col-md-4 col-sm-6 mb-3' key={item.id}>
                        <Cartao item={item} abrir={abrir} />
                    </div>)}</div>
            </section>)}
        </ContentCardBody>
    </ContentCard></Content>;
};
